<template>
  <waajo-dashboard v-if="hasActiveLicense"></waajo-dashboard>
  <waajo-license-picker v-else></waajo-license-picker>
</template>

<script>
import { mapGetters } from "vuex";
import WaajoDashboard from "./copilot.vue";
import WaajoLicensePicker from "./index.vue";

export default {
  name: "dashboard-entry",
  components: {
    WaajoDashboard,
    WaajoLicensePicker
  },
  computed: {
    ...mapGetters(["agentSession"]),
    hasActiveLicense() {
      const session = this.agentSession || {};
      return Boolean(
        (session.license_phone_number &&
          String(session.license_phone_number).trim()) ||
          session.license_id
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/dashboard/entry.vue